export default __webpack_public_path__ + "static/media/cha_medic_breeze.ecced1cb.png";